import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M7.55 35.652h24.9a20.102 20.102 0 0 0 4.614-5.217H2.937a20.104 20.104 0 0 0 4.614 5.217ZM20 0v4.348h12.45A19.914 19.914 0 0 0 20 0Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m17.391 11.705-2.442 1.149 1.3 2.365-2.652-.507-.336 2.68-1.847-1.971-1.848 1.97-.336-2.679-2.652.507 1.3-2.365-2.442-1.15 2.442-1.148-1.3-2.366 2.652.508.336-2.68 1.848 1.971 1.847-1.97.336 2.679 2.652-.508-1.3 2.366 2.442 1.149Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M0 20c0 1.805.24 3.554.689 5.217h38.622C39.759 23.554 40 21.805 40 20H0Zm20-5.217h19.311a19.89 19.89 0 0 0-2.246-5.218H20v5.218Z"
}, null, -1), d = [
  n,
  s,
  c,
  h
];
function i(_, a) {
  return e(), l("svg", o, [...d]);
}
const u = { render: i };
export {
  u as default,
  i as render
};
